import React, { useState } from 'react'
import Header from '../../Core/Header'
import { Section } from '../../Core/Section'
import { addCourierApi } from '../../Services/Operations/ProductAPI'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'

const CourierAdd = () => {


const [courierServiceName,setCourierServiceName]=useState("")
const [contactPerson,setContactPerson]=useState("")
const [contactNumber,setContactNumber]=useState("")
const [email,setEmail]=useState("")
const [website,setWebsite]=useState("")
const [addressLine1,setaddressLine1]=useState("")
const [addressLine2,setAddressLine2]=useState("")
const [city,setCity]=useState("")
const [state,setState]=useState("")
const[country,setCountry]=useState("")
const[postalCode,setPostalCode]=useState("")
const[trackingUrl,setTrackingUrl]=useState("")
const[gstNum,setGstNum]=useState("")
const[status,setStatus]=useState(0)

 const token = useSelector((state) => state.user.token);


const handleSubmit=async(e)=>{
    e.preventDefault()
    const data={
        courierServiceName,contactPerson,contactNumber,email,website,addressLine1,addressLine2,city,
        state,country,postalCode,trackingUrl,gstNum,status
    }

    console.log("data",data);

    try {
        const response = await addCourierApi(data,token)
        console.log("response",response);
        if(response.status===200){
            toast.success("New Courier Added")
            return
        }
        toast.warn("Someting wring check again")
        
    } catch (error) {
        console.log(error);
        toast.error("Failed to add new courier")
        
    }
    
}


  return (
    <div>
         <div id="main_content">
              <Header />
              <div className="page">
                <Section />
                <div
                  className="main_part"
                  style={{
                    display: "flex",
                    flexDirection:"column",
                    alignItems:"start",
                    justifyContent: "space-around",
                    width: "98%",
                  }}
                >

                        <div className="d-flex justify-content-between align-items-center ">
                    <div className="header-action">
                <h1 className="page-title">Courier Add</h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">RNDSAN</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                   Courier Add
                  </li>
                </ol>
              </div>

              <div className="header-action">

              </div>
              </div>

               <div className="card">
                      <div className="card-header">
                        <h3 className="card-title">Add Basic Information</h3>
                        
                      </div>
                      <form className="card-body" onSubmit={handleSubmit}>

                        <div className="form-group row">
                          <label className="col-md-3 col-form-label">
                            Courier Service Name
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                              placeholder='Enter Courier Service Name'
                              value={courierServiceName}
                               onChange={(e)=>setCourierServiceName(e.target.value)}
                             
                            />
                          </div>
                        </div>
                         <div className="form-group row">
                          <label className="col-md-3 col-form-label">
                            Contact Person
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                              placeholder='Enter Contact Person'
                              value={contactPerson}
                               onChange={(e)=>setContactPerson(e.target.value)}
                             
                            />
                          </div>
                        </div>
                         <div className="form-group row">
                          <label className="col-md-3 col-form-label">
                            Contact number
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                              placeholder='Enter Contact number'
                              value={contactNumber}
                               onChange={(e)=>setContactNumber(e.target.value)}
                             
                            />
                          </div>
                        </div>
                         <div className="form-group row">
                          <label className="col-md-3 col-form-label">
                            Email
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                              placeholder='Enter Email'
                              value={email}
                               onChange={(e)=>setEmail(e.target.value)}
                             
                            />
                          </div>
                        </div>
                         <div className="form-group row">
                          <label className="col-md-3 col-form-label">
                           Website
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                              placeholder='Enter Website'
                              value={website}
                               onChange={(e)=>setWebsite(e.target.value)}
                             
                            />
                          </div>
                        </div>
                         <div className="form-group row">
                          <label className="col-md-3 col-form-label">
                            Address Line 1
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                              placeholder='Enter Address'
                              value={addressLine1}
                               onChange={(e)=>setaddressLine1(e.target.value)}
                             
                            />
                          </div>
                        </div>
                         <div className="form-group row">
                          <label className="col-md-3 col-form-label">
                            Address Line 2
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                               placeholder='Enter Address'
                               value={addressLine2}
                               onChange={(e)=>setAddressLine2(e.target.value)}
                             
                            />
                          </div>
                        </div>
                         <div className="form-group row">
                          <label className="col-md-3 col-form-label">
                            City
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                               placeholder='Enter City'
                               value={city}
                               onChange={(e)=>setCity(e.target.value)}
                             
                            />
                          </div>
                        </div>
                         <div className="form-group row">
                          <label className="col-md-3 col-form-label">
                           State
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                               placeholder='Enter State'
                               value={state}
                               onChange={(e)=>setState(e.target.value)}
                             
                            />
                          </div>
                        </div>
                         <div className="form-group row">
                          <label className="col-md-3 col-form-label">
                            Country
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                               placeholder='Enter Country'
                               value={country}
                               onChange={(e)=>setCountry(e.target.value)}
                             
                            />
                          </div>
                        </div>
                         <div className="form-group row">
                          <label className="col-md-3 col-form-label">
                           Postal Code
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                               placeholder='Enter Postal Code'
                               value={postalCode}
                               onChange={(e)=>setPostalCode(e.target.value)}
                             
                            />
                          </div>
                        </div>
                         <div className="form-group row">
                          <label className="col-md-3 col-form-label">
                            Tracking URL
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                               placeholder='Enter Trackng URL'
                               value={trackingUrl}
                               onChange={(e)=>setTrackingUrl(e.target.value)}
                             
                            />
                          </div>
                        </div>
                         <div className="form-group row">
                          <label className="col-md-3 col-form-label">
                          GST Number
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                               placeholder='Enter GST Number'
                               value={gstNum}
                               onChange={(e)=>setGstNum(e.target.value)}
                             
                            />
                          </div>
                        </div>

                         <div className="form-group row">
                          <label className="col-md-3 col-form-label">
                         Status
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                               placeholder='Enter Status'
                               value={status}
                               onChange={(e)=>setStatus(e.target.value)}
                             
                            />
                          </div></div>

                        
                      

                        <div className="col-sm-12">
                          <button type="submit" className="btn btn-primary">
                            Submit
                          </button>
                        </div>
                      </form>
                    </div>


                </div>
                     <div className="section-body">
          <footer className="footer">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  Copyright © 2025{" "}
                  <a href="">Technology support By - Siance Software Pvt Ltd</a>
                  .
                </div>
                {/* <div className="col-md-6 col-sm-12 text-md-right">
                  <ul className="list-inline mb-0">
                    <li className="list-inline-item">
                      <a href="../doc/index.html">Documentation</a>
                    </li>
                    <li className="list-inline-item">
                      <a href="javascript:void(0)">FAQ</a>
                    </li>
                    <li className="list-inline-item">
                      <a
                        href="javascript:void(0)"
                        className="btn btn-outline-primary btn-sm"
                      >
                        Buy Now
                      </a>
                    </li>
                  </ul>
                </div> */}
              </div>
            </div>
          </footer>
        </div>


                </div>
           
                </div>
      
    </div>
  )
}

export default CourierAdd
